/**
 * a2-journal.js — Journal card videos (sections/a2-journal, "Card video" blocks).
 * A card with a video shows the article image until the muted loop is playing. Videos load and play only near the
 * viewport and pause off screen. Pause / play and sound buttons sit in the bottom corners; turning sound on for one
 * card mutes the others. With Reduce Motion or Data Saver nothing autoplays: the play button starts it.
 */
(function () {
  'use strict';
  if (window.A2Journal) return;
  window.A2Journal = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var cards = [];

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }

  function setState(el, state) {
    el.classList.toggle('is-playing', state === 'playing');
    el.classList.toggle('is-paused', state === 'paused');
    el.classList.toggle('is-idle', state === 'idle');
    var btn = el._play;
    if (btn) {
      var playing = state === 'playing';
      btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
    }
  }

  function play(el) {
    var v = el._v;
    if (!v.getAttribute('src')) {
      var src = desktop.matches ? (v.dataset.hd || v.dataset.sd) : (v.dataset.sd || v.dataset.hd);
      if (!src) return;
      v.src = src;
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () { if (v.paused) setState(el, el._started ? 'paused' : 'idle'); });
  }

  function init(el) {
    if (el._a2j) return; el._a2j = true;
    var v = el.querySelector('video');
    if (!v) return;
    el._v = v;
    el._play = el.querySelector('[data-a2-j-play]');
    el._sound = el.querySelector('[data-a2-j-sound]');
    el._auto = !(reduce.matches || saveData);
    cards.push(el);

    v.addEventListener('playing', function () { el._started = true; setState(el, 'playing'); });
    v.addEventListener('pause', function () { if (el._started) setState(el, 'paused'); });
    v.addEventListener('error', function () { setState(el, 'idle'); el._auto = false; });

    if (!el._auto) setState(el, 'idle');

    if (el._play) el._play.addEventListener('click', function () {
      if (!v.paused) { el._userPaused = true; v.pause(); track('journal_video_pause', {}); }
      else { el._userPaused = false; play(el); track('journal_video_play', {}); }
    });
    if (el._sound) el._sound.addEventListener('click', function () {
      var on = v.muted;
      cards.forEach(function (o) {
        if (o !== el && o._v && !o._v.muted) { o._v.muted = true; if (o._sound) { o._sound.setAttribute('aria-pressed', 'false'); o._sound.setAttribute('aria-label', 'Turn sound on'); } }
      });
      v.muted = !on;
      el._sound.setAttribute('aria-pressed', on ? 'true' : 'false');
      el._sound.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      if (on && v.paused) { el._userPaused = false; play(el); }
      track('journal_video_sound', { on: on });
    });

    if (io) io.observe(el); else if (el._auto) play(el);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      el._visible = e.isIntersecting;
      if (e.isIntersecting) { if (el._auto && !el._userPaused) play(el); }
      else if (el._v && !el._v.paused) { el._v.pause(); }
    });
  }, { rootMargin: '200px 0px' }) : null;

  document.addEventListener('visibilitychange', function () {
    cards.forEach(function (el) {
      if (document.hidden) { if (!el._v.paused) { el._wasPlaying = true; el._v.pause(); } }
      else if (el._wasPlaying && el._visible && !el._userPaused) { el._wasPlaying = false; play(el); }
    });
  });

  function scan(root) { (root || document).querySelectorAll('[data-a2-j-video]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
